var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',[_c('span',{staticClass:"heading"},[_vm._v(_vm._s(_vm.text))]),_c('br'),_c('span',{domProps:{"innerHTML":_vm._s(_vm.$rc.htmlLinebreak(_vm.value))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }